function t(transId) {
  return transId;
}

const colorConfig = {
  primaryForeground: '#b082f9',
  secondaryForeground: '#22ddb9',
  screenBackground: '#ffffff',
  separator: '#deddde',
  text: '#393536',
  lightText: '#7b7979',
  placeholder: '#deddde',
  inputBorder: '#deddde',
};

export function formatCountdownTime(seconds) {
  let mins = Math.floor(seconds / 60);
  const hours = Math.floor(mins / 60);
  mins = mins % 60;
  let secs = seconds % 60;
  if (secs < 10) {
    secs = '0' + secs;
  }
  if (hours) {
    return hours + ':' + mins + ':' + secs;
  } else {
    return mins + ':' + secs;
  }
}

class TaskModel {
  constructor(data = {}) {
    this.data = { ...data };
  }

  getData() {
    return { ...this.data };
  }

  static STATUSES = {
    NEW: 'new',
    CONFIRMED: 'confirmed',
    REJECTED: 'rejected',
    COMPLETED: 'completed',
    TRANSFERRED: 'transferred',
  };

  hasUnreadMessagesFor(uid) {
    return this.data.notifications[uid].hasUnreadMessages;
  }

  isChatVisible() {
    return (
      this.data.status === TaskModel.STATUSES.CONFIRMED ||
      this.data.status === TaskModel.STATUSES.NEW
      // this.data.status === TaskModel.STATUSES.COMPLETED
    );
  }

  isProfileVisible(order) {
    const uid = this.data.clientId;
    const profileHidden =
      uid === this.data.clientId &&
      (order?.status === 'open' ||
        order?.status === 'expired' ||
        order?.status === 'exhausted');
    return !profileHidden;
  }

  isCallVisible() {
    return (
      this.data.supportNumber &&
      (this.data.status === TaskModel.STATUSES.CONFIRMED ||
        this.data.status === TaskModel.STATUSES.NEW)
    );
  }

  getAdminSupportNumber() {
    // return '+37067119013';
    if (
      this.data.supportNumber2 &&
      (this.data.status === TaskModel.STATUSES.CONFIRMED ||
        this.data.status === TaskModel.STATUSES.NEW)
    ) {
      return this.data.supportNumber2;
    }
  }

  getFormattedTimerText(_uid, order) {
    const task = this.data;
    const ownTask = false;
    // tasker contacted client - timer is stopped until reject
    if (order?.pausedAt) {
      return null;
    }
    if (ownTask && task.status !== TaskModel.STATUSES.NEW) {
      // for pros timer is shoed only when task is NEW
      return null;
    } else if (
      !ownTask &&
      order.status !== 'open' &&
      order.assignmentStrategy
    ) {
      // for clients timer is showed only for open orders
      return null;
    } else if (
      !ownTask &&
      !order.assignmentStrategy &&
      task.status !== TaskModel.STATUSES.NEW
    ) {
      // for clients timer is showed for manual orders if task is NEW
      return null;
    }
    // for manual orders and pro view task.expiresAt is used, in case of client & open order - order.expiresAt is used
    const expiresAt =
      ownTask || !order.assignmentStrategy ? task.expiresAt : order.expiresAt;
    let timerText = null;
    if (expiresAt) {
      const seconds = +new Date(expiresAt) / 1000 - new Date().getTime() / 1000;
      // console.log('SECONDS', seconds);
      if (seconds >= 0) {
        timerText = formatCountdownTime(Math.floor(seconds));
        // timerText = 'TODO';
      }
    }
    // console.log(timerText);
    return timerText;
  }

  getTaskTag(order) {
    // TODO: refactor to worker/client cases and write unit tests
    let taskTag = {};
    const task = this.data;
    const ownTask = false;
    if (order?.status === 'expired' && !ownTask) {
      taskTag = {
        text: t('tasks.statuses.expired'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (order?.status === 'exhausted' && !ownTask) {
      taskTag = {
        text: t('tasks.statuses.expired'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (order?.status === 'cancelled' && !ownTask) {
      taskTag = {
        text: t('tasks.statuses.cancelled'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (task.status === TaskModel.STATUSES.TRANSFERRED && ownTask) {
      taskTag = {
        text: t('tasks.statuses.transferred'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (
      order?.status === 'open' &&
      !ownTask &&
      !order?.assignmentStrategy
    ) {
      taskTag = {
        text: t('tasks.statuses.reassignable'),
        detailsText: t('tasks.statuses.unconfirmed'),
        style: {
          backgroundColor: colorConfig.primaryForeground,
          color: 'white',
        },
      };
    } else if (
      order?.status === 'open' &&
      !ownTask &&
      order?.assignmentStrategy
    ) {
      taskTag = {
        text: t('tasks.statuses.searching'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (task.status === TaskModel.STATUSES.REJECTED) {
      taskTag = {
        text: t('tasks.statuses.rejected'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (task.status === TaskModel.STATUSES.NEW) {
      if (ownTask) {
        taskTag = {
          text: t('tasks.statuses.needsApproval'),
          style: {
            backgroundColor: colorConfig.primaryForeground,
            color: 'white',
          },
        };
      } else {
        taskTag = {
          text: t('timer.waiting'),
          style: {
            backgroundColor: colorConfig.lightText,
            color: 'white',
          },
        };
      }
    } else if (!ownTask && order.paymentStatus === 'failed') {
      taskTag = {
        text: t('tasks.statuses.paymentFailed'),
        detailsText: 'tasks.statuses.completed',
        style: {
          backgroundColor: colorConfig.primaryForeground,
          color: 'white',
        },
      };
    } else if (task.status === TaskModel.STATUSES.COMPLETED) {
      taskTag = {
        text: t('tasks.statuses.completed'),
        style: {
          backgroundColor: colorConfig.lightText,
          color: 'white',
        },
      };
    } else if (task.status === TaskModel.STATUSES.CONFIRMED) {
      if (ownTask) {
        taskTag = {
          text: t('tasks.statuses.waitingForFinish'),
          style: {
            backgroundColor: colorConfig.primaryForeground,
            color: 'white',
          },
        };
      } else {
        taskTag = {
          text: t('tasks.statuses.arrivalTime'),
          suffix:
            this.data.datetime.dateText +
            ' ' +
            (this.data.datetime.timeText || ''),
          style: {
            backgroundColor: colorConfig.primaryForeground,
            color: 'white',
          },
        };
      }
    }
    return taskTag;
  }
}

export default TaskModel;
